import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M14 20.9999V12.9999H17L17.5 9.99992H14V7.99992C14 6.91908 13.9426 5.99992 15.506 5.99992H17.5V2.99992C17.155 2.95451 16.377 2.99992 15 2.99992C12.1251 2.99992 10 4.80493 10 7.99992V9.99992H8V12.9999H10V20.9999H14Z" fill="currentColor" />
        </svg>
    );
};

export default React.memo(Facebook);
